// dependencies
import { replace } from "yarrr";
import { List } from "immutable";
import debounce from "lodash.debounce";
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { updateUI } from "Actions/ui";

// selectors
import { getPageName, getUI } from "Selectors/ui";
import { getPageSize, getCurrentPage, getFiltersMap } from "./selectors";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

/**
 * Fetches the request based on page state.
 *
 * @param {bool} clearCurrentResults - If true, will clear the current results
 */
export const fetchRequests = (clearCurrentResults) => async (dispatch, getState) => {
	const state = getState();
	const pageSize = getPageSize(state);
	const filters = getFiltersMap(state);
	const currentPage = getCurrentPage(state);

	if (clearCurrentResults) {
		const firstState = getUI(state).withMutations((mutable) => {
			mutable.set("requests", List());
			mutable.set("requestsCount", 0);
		});

		dispatch(changeUI([], firstState));
	}

	// get request
	const request = await dispatch(
		GenerateProcess("GetRequests", {
			limit: pageSize,
			sort: "-start_time",
			url: filters.get("url", ""),
			method: filters.get("method", ""),
			possessed: filters.get("possessed", ""),
			requestID: filters.get("requestID", ""),
			skip: (currentPage - 1) * pageSize,
			authenticated: filters.get("authenticated", ""),
		})
	);

	// create a next state
	const nextState = getUI(state).withMutations((mutable) => {
		mutable.set("requests", request.response.get("requests"));
		mutable.set("requestsCount", request.response.get("requestsCount"));
	});

	// update ui
	dispatch(changeUI([], nextState));
};

/**
 * Searches the provided url string. Adds as a query param.
 * @param {string} url - url string to search
 */
export const urlSearch = (url) => (dispatch, getState) => {
	const state = getState();
	const filters = getFiltersMap(state);

	dispatch(
		replace(
			`/requests/?requestID=${filters.get("requestID", "")}&url=${url}&method=${filters.get(
				"method",
				""
			)}&authenticated=${filters.get("authenticated", "")}&possessed=${filters.get("possessed", "")}`
		)
	);
};

export const requestIDSearch = (requestID) => (dispatch, getState) => {
	const state = getState();
	const filters = getFiltersMap(state);

	dispatch(
		replace(
			`/requests/?requestID=${requestID}&url=${filters.get("url", "")}&method=${filters.get(
				"method",
				""
			)}&authenticated=${filters.get("authenticated", "")}&possessed=${filters.get("possessed", "")}`
		)
	);
};

export const methodChange = (method) => (dispatch, getState) => {
	const state = getState();
	const filters = getFiltersMap(state);

	dispatch(
		replace(
			`/requests/?requestID=${filters.get("requestID", "")}&url=${filters.get("url", "")}&method=${
				method || ""
			}&authenticated=${filters.get("authenticated", "")}&possessed=${filters.get("possessed", "")}`
		)
	);
	dispatch(fetchRequests(true));
};

export const authenticatedChange = (authenticated) => (dispatch, getState) => {
	const state = getState();
	const filters = getFiltersMap(state);

	dispatch(
		replace(
			`/requests/?requestID=${filters.get("requestID", "")}&url=${filters.get("url", "")}&method=${filters.get(
				"method",
				""
			)}&authenticated=${authenticated || ""}&possessed=${filters.get("possessed", "")}`
		)
	);
	dispatch(fetchRequests(true));
};

export const possessedChange = (possessed) => (dispatch, getState) => {
	const state = getState();
	const filters = getFiltersMap(state);

	dispatch(
		replace(
			`/requests/?requestID=${filters.get("requestID", "")}&url=${filters.get("url", "")}&method=${filters.get(
				"method",
				""
			)}&authenticated=${filters.get("authenticated", "")}&possessed=${possessed || ""}`
		)
	);
	dispatch(fetchRequests(true));
};

export const changePage = (page) => async (dispatch) => {
	dispatch(changeUI(["currentPage"], page));
	await dispatch(fetchRequests());

	// window.scrollTo(0, 0);
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	const initialUI = ui;

	// update the ui
	dispatch(changeUI([], initialUI));

	// do the initial fetch
	dispatch(fetchRequests());
};
